export default "__VITE_ASSET__Cjyy0MAh__"